<template>
    <RefundableNotification
        v-if="isRefundable"
        :onClick="onClick"
        :productId="product.Id"
        placement="checkout" />
    <NonRefundableNotification
        v-if="isRefundable === false"
        :onClick="onClick"
        :productId="product.Id" />
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { ActivityProduct, HotelProduct } from '@/api/Cart/cart.interfaces';
    import { getCartProductCancellation } from '@/components/shared/Cancellation/CartCancellation/CartCancellation.helpers';
    import RefundableNotification from '@/components/paymentPage/Message/Variants/RefundableNotification.vue';
    import { useStore } from '@/store';
    import { ProductModalTab, ModalType } from '@/store/general/types';
    import NonRefundableNotification from '@/components/paymentPage/Message/Variants/NonRefundableNotification.vue';
    import { logStatsigCheckoutCancellationPanelOpen } from '@/tracking/statsig/checkout.functions';

    export default defineComponent({
        name: 'CancellationPanel',
        methods: { t },
        components: {
            NonRefundableNotification,
            RefundableNotification,
        },
        props: {
            product: {
                type: Object as PropType<ActivityProduct | HotelProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const store = useStore();

            function onClick() {
                store.dispatch('general/setModal', {
                    type: ModalType.Product,
                    productId: product.Id,
                    activeTab: ProductModalTab.Terms,
                });

                logStatsigCheckoutCancellationPanelOpen(product.Type);
            }

            const productCancellation = getCartProductCancellation(product);
            const isRefundable = productCancellation?.Refundable;

            return {
                isRefundable,
                onClick,
            };
        },
    });
</script>
